var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755052304676,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7606,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M904.5 604.6c0-2.8-0.1-5.7-0.4-8.6V235.7h-0.4v-0.9c0-19.8-7-49.5-40.1-78.8-21.2-18.8-50.7-35.3-87.6-49.1-71.2-26.6-165.1-41.3-264.4-41.3s-193.2 14.7-264.4 41.3c-36.8 13.8-66.3 30.3-87.6 49.1-33.2 29.3-40.1 59-40.1 78.8 0 2.9 0.1 5.7 0.4 8.6v171.8c-0.1 1.4-0.1 2.8-0.1 4.2 0 1.4 0 2.9 0.1 4.2V790c0.1 19.8 7.2 49.3 40.1 78.4 21.2 18.8 50.7 35.3 87.6 49.1 71.2 26.6 165.1 41.3 264.4 41.3s193.2-14.7 264.4-41.3c36.8-13.8 66.3-30.3 87.6-49.1 32.9-29.1 40-58.6 40.1-78.4V613.2c0.3-2.9 0.4-5.8 0.4-8.6zM191.9 336.8c14 8.3 30.6 16.4 50.3 24C314 388.6 409.6 404 511.6 404c102 0 197.8-15.4 269.6-43.3 19.1-7.4 36.1-15.6 50.9-24.5v83.2c0 14.5-23.8 38.4-76.9 59C692.3 503 603.5 517 511.6 517c-91.8 0-180.5-14-243.2-38.5-50.7-19.8-74.7-42.8-76.4-57.3v-84.4z m15.4-126.9c14.4-12.7 36.9-25 65.1-35.6 63.3-23.7 148.3-36.7 239.2-36.7s175.9 13 239.2 36.7c28.2 10.5 50.7 22.8 65.1 35.6 5.8 5.2 15.6 15.2 15.8 24.6v0.5c-0.2 14.4-24 38.1-76.5 58.5C692.3 318 603.5 332 511.6 332S331 318 268.2 293.7c-51.7-20-73.2-41.9-76.3-55.3v-2.7h-0.4v-0.9c0-9.4 9.9-19.6 15.8-24.9z m-15.4 311.5c14.7 8.7 31.5 16.8 50.3 24.2 71.8 28 167.5 43.4 269.4 43.4 102 0 197.7-15.4 269.7-43.4 19-7.4 36-15.6 50.8-24.4v86.9c-3.1 13.4-24.8 35.3-76.8 55.4-63 24.3-151.8 38.3-243.7 38.3-91.6 0-180.1-14-242.7-38.3-53.1-20.6-76.9-44.6-76.9-59.2v-82.9z m624.4 293c-14.4 12.7-36.9 25-65.1 35.6-63.3 23.7-148.3 36.7-239.2 36.7-90.9 0-175.9-13-239.2-36.7-28.2-10.5-50.7-22.8-65.1-35.6-5.9-5.2-15.8-15.4-15.8-24.9v-83.3c14.8 8.8 31.8 17 50.8 24.4 71.7 27.9 167.2 43.2 268.8 43.2 101.9 0 197.7-15.3 269.7-43.1 19.9-7.7 36.7-15.9 50.9-24.2v83.1c0 9.4-9.9 19.6-15.8 24.8z",
    fill: "#1f2937",
    "p-id": 7607
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M731.521085 429.78218a31.2 31.2 0 1 0 61.595038-9.990562 31.2 31.2 0 1 0-61.595038 9.990562Z",
    fill: "#1f2937",
    "p-id": 7608
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M762.7 606.5m-31.2 0a31.2 31.2 0 1 0 62.4 0 31.2 31.2 0 1 0-62.4 0Z",
    fill: "#1f2937",
    "p-id": 7609
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M762.7 793.9m-31.2 0a31.2 31.2 0 1 0 62.4 0 31.2 31.2 0 1 0-62.4 0Z",
    fill: "#1f2937",
    "p-id": 7610
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.f73d24bf.svg";
export { ForwardRef as ReactComponent };